import styled from 'styled-components';

import useDevice from '@hooks/useDevice';
import {
  ArticleWrapper,
  ContentContainer,
  Service,
  StyledSection,
} from '@components/atoms';
import { Article, SectionHeader } from '@components/molecules';
import { WhyWeService } from '@shared/constants/whyWe';

type Props = {
  content: WhyWeService[];
};

function WhyWe({ content }: Props) {
  const { isMobile } = useDevice();

  return (
    <StyledSection>
      <ContentContainer>
        <SectionHeader title="About Us" src="icons/fire-icon.svg" />

        <ArticleWrapper margin="0 0 50px">
          <Article
            align="center"
            titleMaxWidth="450px"
            descriptionMaxWidth="750px"
            wrapAlign="center"
            wrapWidth="100%"
            title="Why We"
            description={
              !isMobile
                ? "Green Line Logistics is more than a carrier – we're a team of dedicated professionals passionate about delivering excellence in every mile we cover."
                : "We're a team of dedicated professionals passionate about delivering excellence in every mile we cover."
            }
          />
        </ArticleWrapper>

        <FeaturesWrapper>
          {content.map((prop) => (
            <Service {...prop} key={prop.title} />
          ))}
        </FeaturesWrapper>
      </ContentContainer>
    </StyledSection>
  );
}

const FeaturesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

export default WhyWe;
